import { render, staticRenderFns } from "./InsurersCreate.vue?vue&type=template&id=20288538"
import script from "./InsurersCreate.vue?vue&type=script&lang=js"
export * from "./InsurersCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports